import { Route, Routes } from "react-router";
import { NotFound } from "../../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../../common/constants";
import { TopAgentType } from "../../../common/enums";
import { Permission } from "../../../common/security/enums";
import PageWithPermission from "../../auth/components/PageWithPermission";
import { SplitCommissionsListContainer } from "./containers/SplitCommissionsListContainer";

export const SplitCommissionsRoutes = () => (
  <Routes>
    <Route
      index
      element={
        <PageWithPermission
          component={<SplitCommissionsListContainer />}
          permissions={[Permission.COMMISSIONS]}
          allowedTopAgents={[TopAgentType.PLUS]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);
